import Container from '../../atoms/container/anonymousModalPerk';
import Icon from '../../atoms/images/anonymousModalIcon';
import Label from '../../atoms/text/anonymousModalLabel';
import { AnonymousModalPerkProps as Props } from '../../../../shared/types/props/modal';

function AnonymousModalPerk({ icon, labelTop, labelBottom }: Props) {
  return (
    <Container>
      <Icon src={icon} />
      <Label>
        {labelTop}
        <br />
        {labelBottom}
      </Label>
    </Container>
  );
}

export default AnonymousModalPerk;
